const machineList = [
  { value: 'Global S – 5.5.5', label: 'Global S – 5.5.5' },
  { value: 'Global S – 5.7.5', label: 'Global S – 5.7.5' },
  { value: 'Global S – 7.10.7', label: 'Global S – 7.10.7' },
  { value: 'Global S - 9.12.8', label: 'Global S - 9.12.8' },
  { value: 'Global S - 9.15.8', label: 'Global S - 9.15.8' },
  { value: 'Global S - 9.20.8', label: 'Global S - 9.20.8' },
  { value: 'Global S - 12.15.10', label: 'Global S - 12.15.10' },
  { value: 'Global S - 12.22.10', label: 'Global S - 12.22.10' },
  { value: 'Global S - 12.30.10', label: 'Global S - 12.30.10' },
  { value: 'Global S - 15.22.10', label: 'Global S - 15.22.10' },
  { value: 'Global S - 15.30.10', label: 'Global S - 15.30.10' },
  { value: 'Global S - HTA', label: 'Global S - HTA' },
  { value: '4.5.4 SF', label: '4.5.4 SF' },
  { value: '7.10.7 SF', label: '7.10.7 SF' },
  { value: 'TIGO SF', label: 'TIGO SF' },
  { value: 'PMM-Xi/PMM-C 8.10.6mess', label: 'PMM-Xi/PMM-C 8.10.6mess' },
  {
    value: 'PMM-Xi/PMM-C/Ultra/Infinity 12.10.6',
    label: 'PMM-Xi/PMM-C/Ultra/Infinity 12.10.6',
  },
  { value: 'PMM-Xi/PMM-C/Ultra 16.12.7', label: 'PMM-Xi/PMM-C/Ultra 16.12.7' },
  { value: 'Reference Xi/HP 5.4.3', label: 'Reference Xi/HP 5.4.3' },
  { value: 'Reference Xi/HP 7.7.5', label: 'Reference Xi/HP 7.7.5' },
  { value: 'Reference Xi/HP 10.7.6', label: 'Reference Xi/HP 10.7.6' },
  { value: 'Reference Xi/HP 12.15.9', label: 'Reference Xi/HP 12.15.9' },
  { value: 'Reference Xi/HP 15.12.9', label: 'Reference Xi/HP 15.12.9' },
  { value: 'Reference Xi/HP 22.12.9', label: 'Reference Xi/HP 22.12.9' },
  { value: 'Reference Xi/HP 30.12.9', label: 'Reference Xi/HP 30.12.9' },
  { value: 'Optiv 321/322', label: 'Optiv 321/322' },
  { value: 'Optiv 443/443 Dual Z', label: 'Optiv 443/443 Dual Z' },
  { value: 'Optiv 663/664 Dual Z', label: 'Optiv 663/664 Dual Z' },
  { value: 'Other', label: 'Other' },
]

export default machineList
